package com.wintermar.inspection.core.ui.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import inspection.composeapp.generated.resources.Manrope_Bold
import inspection.composeapp.generated.resources.Manrope_Regular
import inspection.composeapp.generated.resources.Res
import org.jetbrains.compose.resources.Font

val Manrope
    @Composable get() = FontFamily(
        Font(Res.font.Manrope_Regular, weight = FontWeight.Normal),
        Font(Res.font.Manrope_Bold, weight = FontWeight.Bold),
    )

val AppTypography: Typography
    @Composable get() {
        val defaults = Typography() // Material3 defaults (sizes, weights, letterSpacing, etc.)
        return Typography(
            displayLarge = defaults.displayLarge.copy(fontFamily = Manrope),
            displayMedium = defaults.displayMedium.copy(fontFamily = Manrope),
            displaySmall = defaults.displaySmall.copy(fontFamily = Manrope),
            headlineLarge = defaults.headlineLarge.copy(fontFamily = Manrope),
            headlineMedium = defaults.headlineMedium.copy(fontFamily = Manrope),
            headlineSmall = defaults.headlineSmall.copy(fontFamily = Manrope),
            bodyLarge = defaults.bodyLarge.copy(fontFamily = Manrope),
            bodyMedium = defaults.bodyMedium.copy(fontFamily = Manrope),
            bodySmall = defaults.bodySmall.copy(fontFamily = Manrope),
            labelLarge = defaults.labelLarge.copy(fontFamily = Manrope),
            labelMedium = defaults.labelMedium.copy(fontFamily = Manrope),
            labelSmall = defaults.labelSmall.copy(fontFamily = Manrope),
            titleSmall = defaults.titleSmall.copy(fontFamily = Manrope),
            titleMedium = defaults.titleMedium.copy(fontFamily = Manrope),
            titleLarge = defaults.titleLarge.copy(fontFamily = Manrope)
        )
    }
